import { createPortal } from "react-dom";
import "./ContactAddDialog.scss";
import ContactsList from "./ContactsList";
import { usePrsInfo } from "./effects";
import { useContext } from "react";
import { AppContext } from "../Context/AppContext";
function ContactAddDialog(props) {
	const prsInfo = usePrsInfo();
	const { theme } = useContext(AppContext);
	return createPortal(
		<div
			className='add-dialog-wrapper'
			color={theme.color}
			style={{
				fontSize: `${(16 / theme.scaleFactor) * theme.fontMultiplier}px`,
			}}
		>
			<div className='add-dialog'>
				<ContactsList
					setInfo={props.setInfo}
					updateEstablishedContacts={props.updateEstablishedContacts}
					setAddDialogOpen={props.setAddDialogOpen}
					establishedContacts={props.establishedContacts}
				/>
				<button
					className='close-button'
					onClick={() => props.setAddDialogOpen(false)}
				>
					Закрыть
				</button>
			</div>
		</div>,
		document.getElementById("addContact")
	);
}

export default ContactAddDialog;
